module.exports = __webpack_public_path__ + "img/NPL.0ee90d76.png";